up.compiler('#js-messages', function (el) {
  let cleanUp

  import(/* webpackChunkName: "messages" */ './messages/index.js')
    .then(async ({ default: renderMessages }) => {
      cleanUp = await renderMessages(document.querySelector('#js-messages-app'), el.dataset)
    })
    .catch(error => console.error('An error occurred while loading messages', error)) // eslint-disable-line no-console

  return () => {
    if (cleanUp) {
      cleanUp()
    }
  }
})
